import { makeAutoObservable } from 'mobx'
import { employee } from 'page/catalog/employee/store/EmployeeStore'
import { mx } from 'store/base/mx'
import { User } from 'type/auth'

type Step = 'login' | 'change' | 'logout'

export class EmployeeModalStore {
  readonly data: User | null = null
  private _step: Step = 'logout'

  constructor(user?: User) {
    makeAutoObservable(this)
    this._step = employee.employees.length ? 'change' : 'login'
    this.data = user || null
  }

  get step(): Step {
    return this._step
  }

  set step(step: Step) {
    this._step = step
  }
}

export const employeeModal = mx.ref<EmployeeModalStore>()
